import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { Button } from 'ui/button';
import { Checkmark } from 'ui/icons/action';
import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';

import { addZuoraAccountRequest } from 'modules/billing/actions';

// type Props = {
//   isOpen: boolean,
//   onClose: () => void,
// };

export const InsertZuoraPlanModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [organizationId, setOrganizationId] = useState(null);
  const [accountId, setAccountId] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const addZuoraAccount = () =>
    dispatch(
      addZuoraAccountRequest({
        organizationId,
        accountId,
        accountNumber,
      }),
    );
  const addZuoraSubscription = () => {
    addZuoraAccount();
    onClose();
  };
  return isOpen ? (
    <Modal isModalOpen={isOpen} onClose={onClose} size={MODAL_SIZES.MEDIUM}>
      <ModalHeader>Add Zuora Subscription</ModalHeader>
      <ModalBody>
        <SemanticUI.Grid centered textAlign="center" columns={3}>
          <SemanticUI.Grid.Column>
            <label>Organization ID</label>
            <SemanticUI.Input
              name="organizationId"
              onChange={(_, { value }) => setOrganizationId(value)}
            />
          </SemanticUI.Grid.Column>
          <SemanticUI.Grid.Column>
            <label>Zuora Account ID</label>
            <SemanticUI.Input
              name="accountId"
              placeholder="ex: 2c92a0fd5ecce80c015ee4689d6c41fe"
              onChange={(_, { value }) => setAccountId(value)}
            />
          </SemanticUI.Grid.Column>
          <SemanticUI.Grid.Column>
            <label>Zuora Account Name</label>
            <SemanticUI.Input
              name="accountNumber"
              placeholder="ex: ITBL-00000113"
              onChange={(_, { value }) => setAccountNumber(value)}
            />
          </SemanticUI.Grid.Column>
        </SemanticUI.Grid>
      </ModalBody>
      <ModalFooter>
        <Button onClick={addZuoraSubscription}>
          <Checkmark isColorInherited />
          Add Zuora Subscription
        </Button>
      </ModalFooter>
    </Modal>
  ) : null;
};
